import * as kpisServices from '@/services/kpis.js'
import * as ClubeService from '@/services/clube.js'
import { assertArray } from '@/config/helpers.js'

export default {
  async clubeClientesCadastrados({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'clientesCadastrados', data, state })
    return data
  },
  async clubeClientesCadastradosTotal({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'clientesCadastradosTotal', data, state })
    return data
  },
  async clubeClientesCadastradosChart({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    return data
  },
  async clubeClientesAtivos({ state, commit }, filter) {
    const { data } = await kpisServices.clientesAtivos(filter)
    commit('SET_OBJECT', { name: 'clientesAtivos', data, state })
    return data
  },
  async clubeClientesAtivosChart({ state, commit }, filter) {
    const { data } = await kpisServices.clientesAtivos(filter)
    return data
  },
  async clubeMediaCompras({ state, commit }, filter) {
    const { data } = await kpisServices.mediaCompras(filter)
    commit('SET_OBJECT', { name: 'mediaCompras', data, state })
  },
  async clubeGastoMedio({ state, commit }, filter) {
    const { data } = await kpisServices.gastoMedio(filter)
    commit('SET_OBJECT', { name: 'gastoMedio', data, state })
  },
  async gastoMedio({ state, commit }, filter) {
    const { data } = await kpisServices.gastoMedio(filter)
    return data
  },
  async clubePercentualFaturamentoFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.percentualFaturamentoFidelidade(filter)
    commit('SET_OBJECT', { name: 'percentualFaturamentoFidelidade', data, state })
    return data
  },
  async clubePercentualCuponsFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.percentualCuponsFidelidade(filter)
    commit('SET_OBJECT', { name: 'percentualCuponsFidelidade', data, state })
    return data
  },
  async clubeTicketMedioFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.ticketMedio(filter)
    commit('SET_OBJECT', { name: 'ticketMedioFidelidade', data, state })
    return data
  },
  async clubeTicketMedio({ state, commit }, filter) {
    const { data } = await kpisServices.ticketMedio(filter)
    commit('SET_OBJECT', { name: 'ticketMedio', data, state })
    return data
  },
  async clubePercentualTicketMedio({ state, commit }, filter) {
    const { data } = await kpisServices.percentualTicketMedioFidelidade(filter)
    commit('SET_OBJECT', { name: 'percentualTicketMedio', data, state })
  },
  async clubeFaturamento({ state, commit }, filter) {
    const { data } = await kpisServices.faturamento(filter)
    commit('SET_OBJECT', { name: 'faturamento', data, state })
    return data
  },
  async clubeMediaItensFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.mediaItens(filter)
    return data
  },
  async clubeMediaItens({ state, commit }, filter) {
    const { data } = await kpisServices.mediaItens(filter)
    commit('SET_OBJECT', { name: 'mediaItens', data, state })
    return data
  },
  async clubeCuponsFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.cupons(filter)
    commit('SET_OBJECT', { name: 'cuponsFidelidade', data, state })
    return data
  },
  async clubeFaturamentoFidelidade({ state, commit }, filter) {
    const { data } = await kpisServices.faturamento(filter)
    commit('SET_OBJECT', { name: 'faturamentoFidelidade', data, state })
    return data
  },
  async clubeCuponsFora({ state, commit }, filter) {
    const { data } = await kpisServices.cupons(filter)
    commit('SET_OBJECT', { name: 'cuponsFora', data, state })
  },
  async getCuponsPorCliente({ state, commit }, filter) {
    const { data } = await kpisServices.cuponsPorCliente(filter)
    return data
  },
  async clubeInicioFidelidade({ state, commit }) {
    const { data } = await kpisServices.inicioFidelidade()
    commit('SET_OBJECT', { name: 'inicioFidelidade', data, state })
  },
  async clubeFaturamentoFora({ state, commit }, filter) {
    const { data } = await kpisServices.faturamento(filter)
    commit('SET_OBJECT', { name: 'faturamentoFora', data, state })
  },
  async clubePerformanceOperacional({ state, commit }, filter) {
    const { data } = await kpisServices.performanceOperacional(filter)
    commit('SET_OBJECT', { name: 'performanceOperacional', data: assertArray(data), state })
  },
  async clubePercentualCuponsIdentificados({ state, commit }, filter) {
    const { data } = await kpisServices.percentualCuponsIdentificados(filter)
    commit('SET_OBJECT', { name: 'percentualCuponsIdentificados', data, state })
  },
  async clubePercentualCuponsIdentificadosChart({ state, commit }, filter) {
    const { data } = await kpisServices.percentualCuponsIdentificados(filter)
    return data
  },
  async clubePercentualFaturamentoIdentificado({ state, commit }, filter) {
    const { data } = await kpisServices.percentualFaturamentoIdentificado(filter)
    commit('SET_OBJECT', { name: 'percentualFaturamentoIdentificado', data, state })
  },
  async clubePercentualFaturamentoIdentificadoChart({ state, commit }, filter) {
    const { data } = await kpisServices.percentualFaturamentoIdentificado(filter)
    return data
  },
  async clubeDetalhesOperador({ state, commit }, filter) {
    const { data } = await kpisServices.detalhesOperador(filter)
    commit('SET_OBJECT', { name: 'detalhesOperador', data, state })
  },

  async chartsComparativo({ state, commit }, filter) {
    const data = await ClubeService.comparativoCharts(filter)
    commit('SET_OBJECT', { name: 'comparativoCharts', data, state })
  },

  async cardsComparativo({ state, commit }, filter) {
    const data = await ClubeService.comparativoCards(filter)
    commit('SET_OBJECT', { name: 'comparativoCards', data, state })
  },

  async metricsUnitsComparision({ state, commit }, filter) {
    const { data } = await kpisServices.metricsUnitsComparision(filter)
    commit('SET_OBJECT', { name: 'metricsUnitsComparision', data, state })
    return data
  },

  async loyaltyFirstPurchasesChart({ state, commit }, filter) {
    const { data } = await kpisServices.firstPurchases(filter)
    return data
  },
}
